import React from "react";
import { Card, LinearProgress, Typography } from "@deere/fuel-react";

const CardLoaderComponent = (props) => {
  return (
    <Card
      style={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        maxWidth: 400,
        padding: "60px 30px",
        border: "none",
      }}
      variant="outlined"
    >
      <div
        style={{
          width: "100%",
        }}
      >
        <LinearProgress />
      </div>
      <Typography
        className="font-bold"
        style={{
          marginBottom: "0.25rem",
          marginTop: "1rem",
        }}
        variant="h7"
      >
        Loading {props.desc}...
      </Typography>
      <Typography variant="subtitle2">{props.subtitle}</Typography>
    </Card>
  );
};
export default CardLoaderComponent;
